import { useCallback } from "react";
import { updateOwnAccount, updateUserById } from "../api/accountApi";
import {
  savesThroughSelfEndpoint,
  toSelfEditFields,
} from "../domain/accountSelfEdit";

// Saves the signed-in user's own Settings through the endpoint their role
// allows (domain/accountSelfEdit.js). Resolves with the saved user record;
// a failed save rejects with the API's readable error.
export default function useSaveOwnAccount({ accessToken, userId }) {
  const saveOwnAccount = useCallback(
    async ({ role, selfId, formData }) => {
      const fields = toSelfEditFields(formData);
      if (savesThroughSelfEndpoint(role)) {
        return updateOwnAccount({ accessToken, userId, fields });
      }
      return updateUserById({
        accessToken,
        userId,
        targetUserId: selfId,
        fields,
      });
    },
    [accessToken, userId]
  );

  return { saveOwnAccount };
}
